<div class="container" [ngClass]="{ 'dismissed': isDismissed }">
  <div class="notification-icon" *ngIf="!data?.isError"><i class="material-icons notification-success">check</i></div>
  <div class="notification-icon" *ngIf="data?.isError"><i class="material-icons notification-failure">close</i></div>
  <div class="notification-body">
    <div>{{ data?.message }}</div>
  </div>
  <div class="notification-dismiss"><i class="material-icons" (click)="closeNotification()">close</i></div>
</div>